import React from "react";
import MissingAbout from "./MissingAbout";

function MissingDetails() {
  return (
    <div className="content bg-mainBg px-5 ">
        <div className=" bg-white rounded-xl mt-6 Company_Single-inner">
            <p className="text-xl font-semibold text-black">
              Add 7 missing detail(s)</p>
            <div className="mt-4">
              <MissingAbout title="Education" name="Show qualifications to recruiter" />
              <MissingAbout title="Mobile" name="Recruiters contact verified numbers" />
              <MissingAbout title="Competetive Exam" name="Showcase your expertise" />
              <MissingAbout title="Internship" name="Let recruiters know about your internship" />
              <MissingAbout title="Projects" name="Add your best works" />
            </div>
          </div>
    </div>
  );
}

export default MissingDetails;
